// extracted by mini-css-extract-plugin
export default {"ticketRow":"TicketTypeRow_ticketRow__+C8IB","ticketTitle":"TicketTypeRow_ticketTitle__YF2ew","ticketDescription":"TicketTypeRow_ticketDescription__trw+F"};